<template>
  <div class="max-h-[410px] flex w-full">
    <!--1. level-->
    <div v-for="category in categoryList" :key="category.item" class="space-y-4 flex flex-col w-1/3">
      <OLink
        :href="getCategoryRoute(category)"
        :title="getCategoryName(category)"
        class="font-semibold text-20"
        :style="categoryTextStyle(category[0])"
        @click="onClickDataLayer(getCategoryName(category))"
      >
        {{ getCategoryName(category) }}
      </OLink>
      <!--2. level-->
      <div v-for="subCategory in getCategorySubs(category)" :key="subCategory">
        <OLink
          :href="getCategoryRoute(subCategory)"
          :title="getCategoryName(subCategory)"
          class="text-md font-medium"
          @click="onClickDataLayer(getCategoryName(category), getCategoryName(subCategory))"
        >
          {{ getCategoryName(subCategory) }}
        </OLink>
        <!--3. level-->
        <div class="flex flex-wrap">
          <div v-for="(sub, index) in getCategorySubs(subCategory)" :key="sub">
            <div class="text-13 font-normal text-primary-200">
              <OLink
                :href="getCategoryRoute(sub)"
                :title="getCategoryName(sub)"
                @click="onClickDataLayer(getCategoryName(subCategory), getCategoryName(sub))"
              >
                {{ getCategoryName(sub) }}
              </OLink>
              <span v-if="index !== getCategorySubs(subCategory).length - 1" class="-ml-1">{{ ',&nbsp;' }}</span>
            </div>
          </div>
        </div>
      </div>
      <!--all content-->
      <OLink
        :href="getCategoryRoute(category)"
        :title="getCategoryName(category)"
        class="font-medium text-md text-o-blue"
        :style="categoryTextStyle(category[0])"
      >
        {{ $t('header.content-text', { TEXT: getCategoryName(category) }) }}
      </OLink>
      <div v-if="getCategoryName(category) === 'Goygoy'">
        <a href="/oyun">
          <img src="/svg/header-game.svg" />
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, defineComponent } from '@nuxtjs/composition-api';
import { useTracking } from '~/modules/tracking/composables/useTracking';
import MenuVariantWrapped from '~/modules/common/components/app/header/CategoryMenu/MenuVariantWrapped';
import categoryObject from '~/constants/categories.json';
import { categoryTextStyle } from '~/modules/category/utils/categoryUtils';
import { OLink } from '~/modules/common/components/ui';

export default defineComponent({
  components: { MenuVariantWrapped, OLink },
  props: {
    selectedMenu: {
      type: Object,
    },
  },
  setup(props) {
    const categories = categoryObject.categories;

    const getCategoryRoute = (category) => categories[category]?.href;
    const getCategoryName = (category) => categories[category]?.name;
    const getCategorySubs = (category) => categories[category]?.subs;

    const { sendMenuClickEvent } = useTracking();

    const categoryList = computed(() => {
      const list = [];
      props.selectedMenu.categories.map((item) => {
        list.push([item]);
      });
      return list;
    });

    const onClickDataLayer = (firstLevel = '', secondLevel = firstLevel) => {
      sendMenuClickEvent('desktop', { currentCategory: props.selectedMenu, firstLevel, secondLevel });
    };

    return { categoryTextStyle, getCategoryRoute, getCategoryName, getCategorySubs, categoryList, onClickDataLayer };
  },
});
</script>

<style></style>
